'use strict';

SwaggerEditor.controller('ConfirmReset', function ConfirmReset($scope,
  $uibModalInstance, Editor) {
  $scope.cancel = $uibModalInstance.close;
  $scope.ok = function() {
    Editor.resetSettings();
    $uibModalInstance.close();
  };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/controllers/confirm-reset.js
// module id = 419
// module chunks = 0